import React, { useState, useEffect, useContext } from 'react';
import { IoChevronBackCircle } from "react-icons/io5";
import { IoIosAddCircle } from "react-icons/io";
import { Modal, Navbar, Nav, NavDropdown } from 'react-bootstrap';

import UsersService from '../../../services/users.service';
import AddEditUser from './AddEditUser';
import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';
import ToastContext from 'store/ToastContext';

export default function UsersManagement(props) {
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [data, setData] = useState([]);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
    const [activeId, setActiveId] = useState();
    const [message, setMessage] = useState("");
    const [selectedUser, setSelectedUser] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [action, setAction] = useState("");
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });

    const handleCloseAddUpdateUser = () => {
        setShowAddUpdateModal(false);
        setSpinnerLoading(false);
    }
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    }
    const redirectToActivityLog = (item) => {
        props.history.push({
            pathname: `/ActivityLogForUser/${item.userName}`
        })
    }

    const backhandler = () => {
        props.history.goBack();
    }
    
    useEffect(() => {
        const fetchData = async () => {
            setSpinnerLoading(true);
            var list = await UsersService.getUsers(userInfo.airlineCode);
            setData(list);
            setSpinnerLoading(false);
        }
        fetchData();
    }, [userInfo.airlineCode]);

    const onRowUpdateSubmitted = async (values, action) => {
        setShowAddUpdateModal(false);
        setSpinnerLoading(true);
        if (action === "update") {
            var list = await UsersService.getUsers(values.AirlineCode);
            setData(list);
        }
        else if (action === "insert") {
            if (userInfo) {
                var getUsersAfterInsert = await UsersService.getUsers(userInfo.airlineCode);
                setData(getUsersAfterInsert);
            }
        }
        setSpinnerLoading(false);
    }
    const handleAddUpdateUser = (action, user, index) => {
        setSelectedUser(user);
        setAction(action);
        setActiveId(index);
        setShowAddUpdateModal(true);
    }
    const handleShowDeleteModal = (item, action, index) => {
        setMessage('Are you sure you want to delete the user?');
        setSelectedUser(item);
        setActiveId(index);
        setShowDeleteModal(true);
    }
    const HandleDeleteUser = async (values) => {
        const del = await UsersService.deleteUser(values);
        if (del.code === 0) {
            var list = await UsersService.getUsers(userInfo.airlineCode);
            setData(list);
            openToast("User removed", "success");
        } else {
            openToast("Error user was NOT removed", "error");
            console.error(del.description);
        }

        setShowDeleteModal(false);
    }
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <h2 className='col'>{"Users Management for Airline " + userInfo.airlineCode + " - " + userInfo.airline?.airline?.toUpperCase()}</h2>
                    <div className='col-auto'>
                        <AppButton classes="rightBtn" action={() => handleAddUpdateUser("Add")} label="Add User" icon={<IoIosAddCircle />}></AppButton>
                    </div>
                </div>
                <div>
                    {spinnerLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={6} variant="table" size="28px"/> : (
                        <React.Fragment>
                            <table className="table table-hover table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">First Name </th>
                                    <th scope="col">User Name</th>
                                    <th scope="col">Phone Number</th>
                                    <th scope="col">Fax Number</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((user, i) => {
                                    return (
                                        <tr key={i} className={activeId === i ? 'higlinteActiveRow' : null}>
                                            <td className="col">{user?.lastName}</td>
                                            <td className="col">{user?.firstName}</td>
                                            <td className="col">{user?.userName}</td>
                                            <td className="col">{user?.phoneNumber}</td>
                                            <td className="col">{user?.faxNumber}</td>
                                            <td className="col">
                                                <Navbar.Collapse id="basic-navbar-nav">
                                                    <Nav className="me-auto">
                                                        <NavDropdown className="m-auto" title="..." id="basic-nav-dropdown">
                                                            <NavDropdown.Item onClick={() => redirectToActivityLog(user)}>Activity Log</NavDropdown.Item>
                                                            <NavDropdown.Divider />
                                                            {!user?.ClobReceived ? (<NavDropdown.Item onClick={() => handleAddUpdateUser("Update", user, i)}>Update User</NavDropdown.Item>) : null}
                                                            <NavDropdown.Item onClick={() => handleShowDeleteModal(user, "cancel", i)}>Delete User</NavDropdown.Item>
                                                        </NavDropdown>
                                                    </Nav>
                                                </Navbar.Collapse>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                            {!data.length ? <AppTableNoData /> :
                                    <AppPagination
                                        pageSize={paginationObject.pageSize}
                                        totalRecords={data.length}
                                        currentPage={paginationObject.currPage}
                                        endIndex={paginationObject.endIndex}
                                        startIndex={paginationObject.startIndex}
                                        setPaginationObject={(ele) => {
                                            setPaginationObject((data) => {
                                                return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                            })
                                        }}
                                    ></AppPagination>
                                }
                        </React.Fragment>)
                    }
                </div>
                <div className="marginAtTop">
                    <AppButton icon={<IoChevronBackCircle />} action={backhandler} label="Back"></AppButton>
                </div>
            </div>
            <div>
                <Modal show={showDeleteModal} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Delete User</Modal.Title>
                        <span style={{ cursor: "pointer" }} onClick={handleCloseDeleteModal}>X</span>
                    </Modal.Header>
                    <Modal.Body>{message}</Modal.Body>
                    <Modal.Footer>
                        <div className="col-2">
                            <AppButton action={() => HandleDeleteUser(selectedUser)} label="Yes" isBlock={true}></AppButton>
                        </div>
                        <div className="col-2">
                            <AppButton action={handleCloseDeleteModal} label="No" color="secondary" isBlock={true}></AppButton>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
            <div>
                <Modal show={showAddUpdateModal} animation={false}>
                    <Modal.Header >
                        <Modal.Title>{action} user</Modal.Title>
                        <span style={{ cursor: "pointer" }} onClick={handleCloseAddUpdateUser}>X</span>
                    </Modal.Header>
                    <Modal.Body>
                        <AddEditUser props={props} user={selectedUser} action={action} airlineCode={userInfo.airlineCode} onSubmitted={onRowUpdateSubmitted} />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}